module.exports = __webpack_public_path__ + "static/media/sunyiwen_match_02.610e59bb.png";